// Generated from SVG to Code Figma Plugin

export const BaseLineQuickEdit = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.38856 15.1704C5.00322 15.5561 4.73028 16.0396 4.59908 16.5688L4.0783 18.6693C3.86091 19.5461 4.65375 20.3396 5.53077 20.123L7.64676 19.6004C8.17762 19.4693 8.66254 19.1956 9.04912 18.8089L19.3743 8.47999C20.3825 7.47143 20.3825 5.83663 19.3744 4.82803C18.3654 3.81865 16.7291 3.81886 15.7204 4.82852L5.38856 15.1704Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.13086 4.51465C6.29988 4.87517 6.58981 5.16375 6.9502 5.33301C6.58969 5.50215 6.3 5.79184 6.13086 6.15234C5.9616 5.79196 5.67303 5.50202 5.3125 5.33301C5.67291 5.16388 5.96173 4.87506 6.13086 4.51465Z"
      stroke="currentColor"
      strokeWidth="2.3625"
    />
    <path
      d="M20.5303 15.4883C20.6631 15.772 20.8903 15.9997 21.1738 16.1328C20.8906 16.2657 20.6632 16.4931 20.5303 16.7764C20.3972 16.4928 20.1695 16.2656 19.8857 16.1328C20.1698 15.9998 20.3973 15.7723 20.5303 15.4883Z"
      stroke="currentColor"
      strokeWidth="1.85625"
    />
  </svg>
);
